document.addEventListener("DOMContentLoaded", function () {
  const stickyBar = document.querySelector("#huratips-addtocart-sticky");

  if (stickyBar?.dataset.allVariantsSoldOut === "true") {
    stickyBar.classList.add("is-sold-out");
    stickyBar.setAttribute("aria-disabled", "true");

    stickyBar.querySelectorAll("button, select, input").forEach((control) => {
      control.disabled = true;
    });

    stickyBar
      .querySelectorAll('form[data-type="add-to-cart-form"]')
      .forEach((form) => {
        form.addEventListener("submit", (event) => event.preventDefault(), true);
      });
  }

  window.addEventListener("scroll", function () {
    var e = document.querySelector("#huratips-addtocart-sticky");
    document.querySelector(".product-form__buttons")?.getBoundingClientRect()
      ?.top < 0
      ? e.classList.remove("hide")
      : e?.classList.add("hide");
  });
  const n = document.querySelectorAll(".e420-product-form__quantity"),
    o = document.querySelector('input[name="e420-selected-variant-quantity"]');
  o && (o.value = 1),
    n &&
      n.forEach((e) => {
        e.addEventListener("change", function () {
          const t = this.value;
          n.forEach((e) => {
            (e.value = t),
              o && ((o.value = t), o.dispatchEvent(new Event("change")));
          });
        });
      });
});

document.addEventListener("change", function (e) {
  const sel = e.target.closest(".e420-product-sticky-add-to-cart__select");
  if (!sel) return;

  const wrap =
    sel.closest("variant-selects.e420-sticky-add-to-cart__selects") ||
    document.querySelector("variant-selects.e420-sticky-add-to-cart__selects");
  if (!wrap) return;

  const sectionId = wrap.getAttribute("data-section");
  // Collect option values in the correct order (1 → 3)
  const values = Array.from(
    wrap.querySelectorAll(".e420-product-sticky-add-to-cart__select")
  )
    .sort(
      (a, b) =>
        (parseInt(a.getAttribute("option-position") || "0", 10) || 0) -
        (parseInt(b.getAttribute("option-position") || "0", 10) || 0)
    )
    .map((s) => s.value);

  // Tell the swatch-dropdown script to update its UI
  document.dispatchEvent(
    new CustomEvent("e420:sticky-select-change", {
      bubbles: true,
      detail: { sectionId, values },
    })
  );
});

